/* eslint-disable no-unused-vars */
import { Link } from 'react-router-dom';
import styled, { keyframes } from 'styled-components';
import { Palette } from 'config';

const shine = keyframes`
  0% { transform: translateX(-100%); }
  100% { transform: translateX(100%); }
`;

export const Box = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100vw;
  position: absolute;
  top: 0;
  left: 0;
  background-color: #060429;
  overflow-y: auto;
  overflow-x: hidden;
  box-sizing: border-box;
  padding: 40px 0;
`;

export const LoaderBox = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  z-index: 99999;
`;

export const StyledForm = styled.form`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 500px;
  margin: auto;
  position: relative;
  z-index: 10;

  /* Glassmorphism */
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(24px);
  -webkit-backdrop-filter: blur(24px);
  padding: 32px;
  @media (min-width: 768px) {
    padding: 40px;
  }
  border-radius: 24px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  box-sizing: border-box;

  /* Form Glow Effect */
  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(to right, rgba(46, 185, 167, 0.2), rgba(53, 153, 231, 0.2));
    border-radius: 24px;
    filter: blur(40px);
    z-index: -1;
  }
`;

export const PassValidationBox = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  padding: 16px;
  background: rgba(255, 255, 255, 0.02);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  margin-top: 12px;
`;

export const IconWrap = styled.div`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 16px;
  height: 16px;
  transform: translate(-2px, -2px) rotate(90deg);

  svg {
    width: 9px;
    height: 6px;
  }
`;

export const ValidationItem = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  color: ${({ isRed, isGreen }) =>
    isRed ? `${Palette.Red._600}` : isGreen ? `#2eb9a7` : `${Palette.PrimaryGray._500}`};
  margin-left: 4px;
  font-size: 11px;
  line-height: 16px;
  transition: all 0.4s ease-in-out;
  font-family: 'Lato', system-ui, sans-serif;

  svg {
    fill: ${({ isRed, isGreen }) =>
      isRed ? `${Palette.Red._600}` : isGreen ? `#2eb9a7` : `${Palette.PrimaryGray._500}`};
    transition: all 0.4s ease-in-out;
  }
`;

export const Separator = styled.div`
  height: 1px;
  background: linear-gradient(to right, transparent, rgba(255, 255, 255, 0.2), transparent);
  margin-bottom: 24px;
  width: 100%;
`;

export const RadioBoxGroup = styled.div`
  display: flex;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 12px;
  overflow: hidden;
  margin-bottom: 24px;
  width: 100%;
  box-sizing: border-box;
`;

export const RadioBtn = styled.button`
  flex: 1;
  height: 48px;
  border: none;
  background: ${(props) => (props.active ? 'rgba(46, 185, 167, 0.15)' : 'transparent')};
  color: ${(props) => (props.active ? '#2eb9a7' : '#a0aec0')};
  font-size: 15px;
  font-weight: 600;
  font-family: 'Lato', system-ui, sans-serif;
  cursor: pointer;
  transition: all 0.2s ease;
  box-sizing: border-box;

  border-bottom: 3px solid ${(props) => (props.active ? '#2eb9a7' : 'transparent')};

  &:first-child {
    border-right: 1px solid rgba(255, 255, 255, 0.15);
  }

  &:hover {
    color: ${(props) => (props.active ? '#2eb9a7' : '#fff')};
    background: ${(props) =>
      props.active ? 'rgba(46, 185, 167, 0.15)' : 'rgba(255, 255, 255, 0.02)'};
  }
`;

export const RadioTitle = styled.div`
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #a0aec0;
  margin: 0px 0px 8px;
  font-family: 'Lato', system-ui, sans-serif;
`;

export const FlexCenter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
`;

export const Label = styled.p`
  font-size: 40px;
  font-weight: 700;
  line-height: 48px;
  font-family: 'Lato', system-ui, sans-serif;
  background: linear-gradient(135deg, #6ce8cf 0%, #2eb9a7 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  padding-bottom: 4px;
  margin: 0;
`;

export const Paragraph = styled.p`
  font-size: 12px;
  line-height: 18px;
  color: #a0aec0;
  margin-bottom: 24px;
  font-family: 'Lato', system-ui, sans-serif;
`;

export const Footer = styled.p`
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: #a0aec0;
  text-align: center;
  font-family: 'Lato', system-ui, sans-serif;
`;

export const StyledLink = styled(Link)`
  color: #2eb9a7;
  font-weight: 700;
  text-decoration: none;
`;

export const OuterLink = styled.a`
  color: #2eb9a7;
  text-decoration: none;
`;

export const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;
  width: 100%;
`;

export const InputLabel = styled.label`
  font-size: 14px;
  color: #a0aec0;
  margin-bottom: 8px;
  font-family: 'Lato', system-ui, sans-serif;
  font-weight: 500;
`;

export const InputWrapper = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  background: rgba(255, 255, 255, 0.05);
  border: 2px solid ${(props) => (props.error ? '#ff4d4f' : 'rgba(255, 255, 255, 0.2)')};
  border-radius: 12px;
  padding: 0 16px;
  height: 48px;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  box-sizing: border-box;

  &:hover {
    border-color: ${(props) => (props.error ? '#ff4d4f' : 'rgba(255, 255, 255, 0.35)')};
    transform: translateY(-2px);
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  }

  &:focus-within {
    border-color: ${(props) => (props.error ? '#ff4d4f' : '#2eb9a7')};
    transform: translateY(-2px);
    box-shadow: 0 4px 20px rgba(46, 185, 167, 0.15);
  }
`;

export const StyledInput = styled.input`
  flex: 1;
  background: transparent;
  border: none;
  outline: none;
  color: #fff;
  font-size: 15px;
  font-family: 'Lato', system-ui, sans-serif;
  height: 100%;
  width: 100%;
  box-sizing: border-box;

  &::placeholder {
    color: rgba(255, 255, 255, 0.3);
  }

  &:-webkit-autofill,
  &:-webkit-autofill:hover,
  &:-webkit-autofill:focus,
  &:-webkit-autofill:active {
    -webkit-text-fill-color: #fff !important;
    -webkit-box-shadow: 0 0 0px 1000px transparent inset !important;
    transition: background-color 5000s ease-in-out 0s;
  }
`;

export const InputIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: rgba(255, 255, 255, 0.4);
  margin-left: 8px;
  user-select: none;
  transition: color 0.2s ease;

  &:hover {
    color: rgba(255, 255, 255, 0.8);
  }

  svg {
    width: 20px;
    height: 20px;
  }
`;

export const ErrorText = styled.span`
  color: #ff4d4f;
  font-size: 12px;
  margin-top: 4px;
  font-family: 'Lato', system-ui, sans-serif;
`;

export const SignUpButton = styled.button`
  width: 100%;
  height: 48px;
  background: linear-gradient(to right, #2eb9a7, #7de0cc);
  color: white;
  border: none;
  border-radius: 12px;
  font-weight: 600;
  font-family: 'Lato', system-ui, sans-serif;
  cursor: pointer;
  box-shadow: 0 10px 15px -3px rgba(46, 185, 167, 0.3);
  transition: all 0.2s ease;
  overflow: hidden;
  position: relative;
  margin-bottom: 24px;

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(to right, rgba(255, 255, 255, 0.3), transparent);
    animation: ${shine} 2.5s linear infinite;
    pointer-events: none;
  }

  &:hover:not(:disabled) {
    transform: scale(1.02);
  }

  &:active:not(:disabled) {
    transform: scale(0.98);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const SubmitSuccessfulBox = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 500px;
  margin: auto;
  position: relative;
  z-index: 10;

  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(24px);
  -webkit-backdrop-filter: blur(24px);
  padding: 32px;
  @media (min-width: 768px) {
    padding: 40px;
  }
  border-radius: 24px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  box-sizing: border-box;
  text-align: center;
`;

export const SuccessText = styled.p`
  color: #a0aec0;
  font-size: 14px;
  line-height: 20px;
  margin-top: 24px;
  font-family: 'Lato', system-ui, sans-serif;
`;

export const SuccessLink = styled.span`
  color: #2eb9a7;
  font-weight: 700;
  cursor: pointer;
  font-family: 'Lato', system-ui, sans-serif;
`;
